import { Radio, RadioGroupProps } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import React from 'react'
import { SelectOption } from '@/common/types/components.def.ts'
import { cn } from '@/utils/style.ts'
import { CheckboxOptionType } from 'antd/es/checkbox/Group'

type CustomRadioProps = {
  col?: number
  value?: string
  onChange?: (value: string) => void
  options: SelectOption[]
  disabled?: boolean
}

export const CustomRadio: React.FC<CustomRadioProps> = ({
  value = [],
  onChange,
  options,
  disabled,
  col,
  ...props
}) => {

  return (
    <Radio.Group
      {...props}
      className={cn('grid grid-cols-4', {
        [`grid-cols-${col}`]: col && col > 0,
      })}
      options={options as CheckboxOptionType[]}
      value={value}
      onChange={e => onChange?.(e.target.value)}
      disabled={disabled}
    />
  )
}


type AntdFormCustomRadioProps = {
  col?: number
  options: SelectOption[]
  disabled?: boolean
  optionType?: RadioGroupProps['optionType']
  buttonStyle?: RadioGroupProps['buttonStyle']
} & AntdFormItemProps

export const AntdFormRadio: React.FC<AntdFormCustomRadioProps> = ({
  fieldProps,
  options,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <CustomRadio {...props} options={options} />
    </AntdFormItem>
  )
}